import { Link } from "react-router-dom";

const NavLink = ({ label, pathName, isSelected, handleClick }) => (
  <Link className={`${isSelected ? "selected" : ""}  option`} to={pathName} onClick={handleClick}>
    {label}
  </Link>
);

export default NavLink;
